import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../app/api";
import BreadCrumb from "../../components/BreadCrumb";
import Table from "../../components/Table";
import PDF from "../policies/pdf";
import AgreementPDF from "../agreement/pdf";
import Loader from "../../components/Loader";
import FormField2 from "../../components/FormField";
import { FormField } from "../invoices/addInvoice";

import { Box, Typography } from "@mui/material";
import SubmitButton from "../../components/SubmitButton";
import useAlert from "../../hooks/useAlert";
import Model from "../../components/model";
import { keys } from "../../config/keys";
import { convertDateToDDMMYYYY, ddmmyyyy } from "../../config/functions";
export default function Default() {
  const location = useLocation();
  const { showAlert } = useAlert();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setloading] = useState(false);
  const [agree, setAgree] = useState(false);
  const [show, setShow] = useState(false)
  const [emailData, setEmailData] = useState({
    submittedEmail: '',
    submittedName: '',
  })
  let fields = [
    {
      value: emailData?.submittedEmail,
      setValue: (value) => setEmailData({ ...emailData, submittedEmail: value }),
      label: "Enter Email",
      placeholder: "Enter Email",
      type: "email",
      id: "submittedEmail",
      required: true,
    },
    {
      value: emailData?.submittedName,
      setValue: (value) => setEmailData({ ...emailData, submittedName: value }),
      label: "Enter Name",
      placeholder: "Enter Name",
      type: "text",
      id: "submittedName",
      required: true,
    },
  ]
  const id = queryParams.get("id");
  const isUser = queryParams.get("isUser");
  const userID = queryParams.get("userID");
  const allowed = queryParams.get("allowed");
  function customDecode(encodedEmail) {
    if (!isUser) {
      return encodedEmail
        ?.split("-")
        ?.map((code) => String.fromCharCode(code - 5))
        .join("");
    }
  }
  const encodedEmail = queryParams.get("email");
  const email = customDecode(encodedEmail);
  const [data, setData] = useState([]);
  const [isSubmitted, setisSubmitted] = useState(false);
  const [shareable, setShareable] = useState({});
  const [signatureHandler, setsignatureHandler] = useState("");
  const labels = [
    "#",
    shareable.forFeature == "policy" || shareable.forFeature == "agreement" ? "Title" : "Name",
    shareable.forFeature == "policy" || shareable.forFeature == "agreement" ? "Last Reviewed" : shareable.forFeature == "management system" ? "Created at" : "Size",
    "File",
  ].filter((item) => item);
  const getData = async () => {
    try {
      const response = await api.get(`/share/get?id=${id}&isUser=${isUser}`);
      if (response.data?.status) {
        setShareable(response.data.result);
        const dataa = response.data?.result?.data
          ? response.data?.result?.data.map((item, index) => {
            return {
              data: item,
              fields: [
                index + 1,
                item?.title || item.name,
                ddmmyyyy(item?.lastReviewed) || item.size || convertDateToDDMMYYYY(item.createdAt),
                response.data.result?.forFeature == "policy" ? (
                  <PDFDownloadLink
                    document={<PDF data={item} />}
                    fileName={item?.title + `.pdf`}
                  >
                    {() => {
                      return (
                        <button className="btn btn-sm btn-success">
                          Open
                        </button>
                      );
                    }}
                  </PDFDownloadLink>
                ) : response.data.result?.forFeature == "agreement" ? (
                  <PDFDownloadLink
                    document={<AgreementPDF data={item} />}
                    fileName={item?.title + `.pdf`}
                  >
                    {() => {
                      return (
                        <button className="btn btn-sm btn-success">
                          Open
                        </button>
                      );
                    }}
                  </PDFDownloadLink>
                ) : (
                  <a
                    href={`${keys.BASE_URL}/${item.url}`}
                    target="_blank"
                    className="btn btn-sm btn-success"
                  >
                    Open
                  </a>
                ),
              ].filter((it) => it),
            };
          })
          : [];
        if (response.data?.result?.allowedEmails?.filter(item => item.email == email).length < 1 && !isUser && allowed != 'all') {
          showAlert("Restricted page!", "danger");
        } else {
          if (
            userID === localStorage.getItem("_id") ||
            response.data?.result?.allowedEmails?.filter(item => item.email == email).length > 0
            || allowed == 'all'
          ) {
            setData(dataa);
          } else {
            console.log('in else')
            showAlert("Restricted page!", "danger");
          }
        }
      } else {
        showAlert(response.data?.message, "danger");
      }
    } catch (error) {
    } finally {
      // setloading(false)
    }
  };
  const submitConcent = async () => {
    setloading(true);
    try {
      const formData = new FormData();
      formData.append("image", signatureHandler);
      // formData.append("submittedEmail", email);
      // formData.append("shareableID", shareable._id);
      const response = await api.put(`/shareSubmissions/update`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        params: {
          submittedEmail: allowed == 'all' ? emailData.submittedEmail : email,
          submittedName: emailData.submittedName,
          shareableID: shareable._id,
          allowed
        },
      });
      if (response.data?.status) {
        showAlert("Confirmation Submitted!", "success");
        setsignatureHandler(null);
        // setShareable({})
        setisSubmitted(true);
        email = "";
      } else {
        showAlert(response.data?.message, "danger");
      }
    } catch (error) {
    } finally {
      setloading();
    }
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (allowed == 'all') setShow(true)
  }, [allowed])
  return (
    <div
      style={{
        border: "15px solid #0d6efd50",
        padding: "40px",
        minHeight: "100vh",
      }}
    >
      {allowed == 'all' && <Model title="Form Information" show={show} handleClose={() => { }}>
        {fields.map((item) => (
          <div className="col-12">
            <FormField field={item} />
          </div>
        ))}
        <div className="d-flex justify-content-center mt-4 gap-2">

          <SubmitButton
            title={"Continue"}
            loading={false}
            onClick={() => {
              setShow(false);
            }}
            color={"success"}
            loaderColor={"white"}
            disabled={
              emailData.submittedEmail == "" ||
              emailData.submittedName == "" 
              // ||
              // !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailData.submittedEmail)
            }
          />
        </div>
      </Model>}
      <BreadCrumb
        flow={[
          { label: "Share", to: "/share" },
          { label: "Home", to: "/" },
          { label: "Share", to: "/share" },
        ]}
      />
      {data.length > 0 ? (
        <>
          <Table data={data} labels={labels} />
          {!isUser && (
            <Box
              sx={{
                padding: "10px",
              }}
            >
              <FormField2
                item={{
                  value: [signatureHandler],
                  setValue: (value, checkbox) => {
                    setsignatureHandler(value);
                  },
                  type: "signature",
                }}
                disabled={false}
              />
            </Box>
          )}
          {!isUser && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                // marginBottom: "20px",
              }}
            >
              <input
                type="checkbox"
                value={agree}
                onChange={(e) => {
                  setAgree(e.target?.checked);
                }}
              />
              <Typography style={{ marginLeft: "6px" }}>
                I confirm that I have received, read, understood and agree to the attached document(s).
              </Typography>
            </Box>
          )}

          {!isUser && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                marginTop: "15px",
              }}
              className="d-flex justify-between"
            >
              <SubmitButton
                title={"Submit"}
                loading={loading}
                onClick={() => {
                  // setData({ ...data, description: data.aiResponse });
                  submitConcent();
                }}
                color={"success"}
                loaderColor={"white"}
                disabled={
                  signatureHandler == "" || !agree || isSubmitted
                }
              />
            </Box>
          )}
        </>
      ) : (
        <Loader loading={true} center />
      )}
    </div>
  );
}
